"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _Message = require("../../../ui-components/Message");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var stateToMessageTypeMapping = {
  waiting: 'loading',
  success: 'success',
  error: 'warning'
};

var statusMessage = function statusMessage(status, date, error) {
  if (status === 'waiting') {
    return (0, _preact.h)("div", null, " Data import is in progress.");
  }

  if (status === 'success') {
    return (0, _preact.h)("div", null, "Last imported at ", (0, _preact.h)(SyncDate, {
      date: date
    }), " (CET).");
  }

  return (0, _preact.h)("div", null, error, " .Import failed at ", (0, _preact.h)(SyncDate, {
    date: date
  }), " (CET).");
};

var options = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  hourCycle: 'h23',
  minute: '2-digit'
};

var SyncDate = function SyncDate(_ref) {
  var date = _ref.date;
  var formattedDate = new Date(date).toLocaleDateString('en-US', options);
  return (0, _preact.h)("span", null, formattedDate);
};

var TicketSyncStatus = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TicketSyncStatus, _Component);

  var _super = _createSuper(TicketSyncStatus);

  function TicketSyncStatus(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TicketSyncStatus);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "timeout", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "keepPolling", void 0);
    _this.timeout = 0;
    _this.keepPolling = true;

    _this.setState({
      isSyncTicketDataActive: props.isSyncTicketDataActive,
      status: null
    });

    _this.fetchStatus = _this.fetchStatus.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleResponse = _this.handleResponse.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TicketSyncStatus, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.state.isSyncTicketDataActive) {
        return;
      }

      this.fetchStatus();
    }
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(prevProps) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.props.isSyncTicketDataActive !== prevProps.isSyncTicketDataActive) {
                  this.setState({
                    isSyncTicketDataActive: this.props.isSyncTicketDataActive
                  });
                  this.fetchStatus();
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "handleResponse",
    value: function handleResponse(_ref2) {
      var data = _ref2.data;
      var keepPolling = this.keepPolling && data.status !== 'error';

      if (keepPolling) {
        this.timeout = window.setTimeout(this.fetchStatus, 30 * 1000);
      }

      this.keepPolling = keepPolling;
      this.setState({
        status: data
      });
    }
  }, {
    key: "handleError",
    value: function handleError(_ref3) {
      var _ref4;

      var response = _ref3.response;
      // eslint-disable-next-line no-mixed-operators
      this.keepPolling = (_ref4 = response && response.status >= 500) !== null && _ref4 !== void 0 ? _ref4 : false;
      this.setState({
        status: null
      });
    }
  }, {
    key: "fetchStatus",
    value: function fetchStatus() {
      clearTimeout(this.timeout);

      _axios.default.get('/integration/zendesk/fetchSyncTicketStatus').then(this.handleResponse).catch(this.handleError);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          status = _this$state.status,
          isSyncTicketDataActive = _this$state.isSyncTicketDataActive;

      if (!status) {
        return null;
      }

      if (!isSyncTicketDataActive) {
        return null;
      }

      return (0, _preact.h)("div", {
        className: "integrations-zendesk__ticket-sync-status integration-zendesk-sync-status"
      }, this.getMessageForStatus(status));
    }
  }, {
    key: "getMessageForStatus",
    value: function getMessageForStatus(_ref5) {
      var status = _ref5.status,
          date = _ref5.date,
          error = _ref5.error;
      var messageVariant = stateToMessageTypeMapping[status];
      return (0, _preact.h)("div", null, (0, _preact.h)(_Message.Message, {
        variant: messageVariant,
        fullWidth: true
      }, (0, _preact.h)("div", null, statusMessage(status, date, error), " ")));
    }
  }]);
  return TicketSyncStatus;
}(_preact.Component);

var _default = TicketSyncStatus;
exports.default = _default;